document.addEventListener("DOMContentLoaded", function () {
  function positionFooters() {
    const sections = document.querySelectorAll(".index-section-half");

    sections.forEach((section) => {
      const centerDiv = section.querySelector(".section-center-div");
      const footer = section.querySelector(".section-footer");

      if (centerDiv && footer) {
        // Get the bottom position of the center div
        const centerDivRect = centerDiv.getBoundingClientRect();
        const sectionRect = section.getBoundingClientRect();

        // Calculate relative position from bottom of center div
        const bottomPosition = centerDivRect.bottom - sectionRect.top + 2.5;

        // Get computed left offset (matches CSS media query)
        const computedStyle = window.getComputedStyle(centerDiv);
        const left = computedStyle.left || "25px";
        footer.style.left = left;

        // Calculate width to match centerDiv's width and left
        const sectionWidth = section.offsetWidth;
        const centerDivLeft = parseFloat(left);
        const centerDivWidth = centerDiv.offsetWidth;
        footer.style.width = `${centerDivWidth}px`;

        // Update footer position
        footer.style.top = `${bottomPosition}px`;
        footer.style.bottom = "auto"; // Remove bottom positioning
      }
    });
  }

  // Run on load
  positionFooters();

  // Run on window resize
  window.addEventListener("resize", positionFooters);
});
